<template>
  <el-table-column
    prop="delivery_date"
    sortable="custom"
    label="Kiállítás dátuma"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.delivery_date | date }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'delivery_date',
  };
</script>
